import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { LayoutService } from '../../layout.service';
import { Field } from '../../field';
import { RecordModel } from '../../record-model';
import { SectionType } from '@app/models/module-structure';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.less'],
})
export class InputSelectComponent extends Field {
  SectionType = SectionType;

  global = g;

  @Input() displayPlaceHolder = true;
  get value(): string {
    if (
      this.recordProperty !== undefined &&
      this.recordProperty.ValueAsObject != null
    ) {
      // console.log('get value of ' + this.recordProperty.Name);
      return this.recordProperty.ValueAsObject.toString();
    }
  }

  set value(newValue: string) {
    let shouldChange = false;
    if (newValue !== this.recordProperty.ValueAsObject) {
      shouldChange = true;
    }

    if (newValue != null && newValue !== undefined) {
      this.recordProperty.ValueAsObject = newValue.toString();
    } else {
      this.recordProperty.ValueAsObject = '';
    }

    if (shouldChange) {
      this.recordProperty.Options.forEach((option) => {
        if (option.Code == this.recordProperty.ValueAsObject) {
          if (option.DBValue != null) {
            //this.recordProperty.Value = option.DBValue;
            this.recordProperty.DBValue = option.DBValue;
          } else {
            //this.recordProperty.Value = this.recordProperty.ValueAsObject;
            this.recordProperty.DBValue = this.recordProperty.ValueAsObject;
          }
        }
      });

      this.valueChanged();
    }
  }

  compareFn = (o1: any, o2: any): boolean => {
    const hasNewLines = /\r?\n/.test(o1) || /\r?\n/.test(o2);
    if (hasNewLines) {
      return o1.replace(/[\r\n]+/g, ' ') === o2.replace(/[\r\n]+/g, ' ');
    } else {
      return o1 === o2;
    }
  };

  constructor(public layoutService: LayoutService, private cdr: ChangeDetectorRef) {
    super(layoutService);
  }

  selectValueChanged() {
    if (this.field.AdditionalInformationParsed.IsMultiple) {
      if (
        this.recordProperty.ValueAsObjectArr === null ||
        this.recordProperty.ValueAsObjectArr === undefined ||
        this.recordProperty.ValueAsObjectArr.length === 0
      ) {
        this.recordProperty.Value = '';
        this.recordProperty.ValueAsObject = '';
      } else {
        console.log('select Value: ', this.recordProperty.ValueAsObject);
        this.recordProperty.ValueAsObject =
          this.recordProperty.ValueAsObjectArr.join(',');
      }
    }

    this.valueChanged();
  }

  getOptions(field) {
    RecordModel.getOptions(
      field,
      this.recordModel,
      this.recordProperty,
      this.sectionTagName,
      this.lineId,
      this.recordCategory,
      this.layoutService,
      this.moduleStructure
    );

    this.cdr.detectChanges();
  }

  initField(): void {
    this.getOptions(this.field);
  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngOnInit() {
    super.ngOnInit();
    if (this.field.AdditionalInformationParsed.SelectOptionsAsCards) {
      this.getOptions(this.field);
    }
    if (this.field.AdditionalInformationParsed.IsMultiple) {
      if (
        this.recordProperty.ValueAsObject != null &&
        this.recordProperty.ValueAsObject != undefined
      ) {
        this.getOptions(this.field);
        this.recordProperty.ValueAsObjectArr =
          this.recordProperty.ValueAsObject.toString().split(',');
      }
    }
  }

  log(event) {
    console.log(event);
  }

  // compareFunAc = (o1: Option | string, o2: Option): boolean => {
  //   if (o1) {
  //     return typeof o1 === 'string' ? o1 === o2.label : o1.value === o2.value;
  //   } else {
  //     return false;
  //   }
  // };
}
